import React, { useEffect, useState } from 'react';
import { langData } from "../libs/Utils";
import { convertMarkdownToHTML } from "../libs/Sanitizer";
import YouTube from 'react-youtube';
import Data from '../data/worktemplate.json';


export const WorkTemplate = (props) => {
    const [imageWidth, setImageWidth] = useState(0);
    const [youtubeHeight, setYoutubeHeight] = useState(0);
    const [data, setData] = useState(Data);

    document.addEventListener('DOMContentLoaded', event => {
        new ParallaxEffectBackground();
    });

    const { lang, id, ua } = props;
    const nowData = langData(lang, data);
    const [loaded, setLoaded] = useState(false);
    const opts = {
        width: '100%',
        height: '100%',
    };

    useEffect(() => {
        setLoaded(true);
        setImageWidth(document.getElementById("header").clientWidth);

        const accessData = async () => {
            const response = await fetch("/works/" + id + "/content.json");
            const body = await response.json();
            setData(body); // stateに反映する
        };
        accessData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setYoutubeHeight(document.getElementById("youtube").clientWidth * 9 / 16 * (ua === "pc" ? 0.8 : 1.0));
    }, [youtubeHeight, ua]);

    const createAuthors = (authors, key) => {
        const al = authors.length;
        return (
            <span>
                {authors.map((a, i) => {
                    let comma = (i < al - 1) ? ((i === al - 2 && lang === "ja") ? ", and " : ", ") : "";
                    return (
                        <span key={key + '_' + i}>
                            <span className={(a === "Yuki Ban" || a === "伴祐樹") ? 'me' : 'author'}>{a}</span>
                            {comma}
                        </span>
                    );
                })}
            </span>)
    }

    const createPubLine = (data, key) => {
        return (
            <li key={key} className="publine work-pub">
                <div>
                    {createAuthors(data.authors, key)}
                    <span>{". "}</span>
                    <span>{data.when}</span>
                    <span>{". "}</span>
                    <span>{data.title}</span>
                    <span>{". "}</span>
                    <span>{(data.where === "" ? [data.publish, data.vol] : [data.publish, data.vol, data.where]).join(", ")}</span>
                    <span className="award" style={{ display: (data.award === "" ? "none" : "inline-block") }}>{data.award}</span>
                    <a className="doi" href={data.doi}>{"[doi]"}</a>
                </div>
            </li>
        );
    }

    const contentClass = (ua === "pc" ? "contact-content content-offset" : "contact-content");

    return (
        <div className={"page-wrapper " + (loaded ? "opacity-one" : "opacity-zero")} >
            {ua === "pc" ?
                <div id="work-header">
                    <div className="work-title">
                        <p className="title-word" dangerouslySetInnerHTML={convertMarkdownToHTML(nowData.title)} />
                    </div>
                    <div className="container"
                        style={{
                            backgroundImage: 'url("/works/' + id + '/' + nowData.top + '")',
                            backgroundPositionY: (nowData.posY === undefined ? "0" : nowData.posY),
                            backgroundSize: imageWidth
                        }} />
                </div> :
                <div id="work-header-sp">
                    <div className="work-title-sp">
                        <p className="title-word-sp" dangerouslySetInnerHTML={convertMarkdownToHTML(nowData.title)} />
                    </div>
                    <div className="container-sp"
                        style={{
                            backgroundImage: 'url("/works/' + id + '/' + nowData.top + '")',
                            backgroundSize: "auto 200px",
                            backgroundPositionY: "100px",
                            backgroundRepeat: "no-repeat"
                            //backgroundPositionY: (nowData.posYsp === undefined ? "100" : nowData.posYsp),
                            //backgroundPositionX: (nowData.posXsp === undefined ? "15" : nowData.posXsp),
                            //backgroundSize: (imageWidth - 30)
                        }} />
                </div>}
            <div id="contact" className="work-about">
                <div className="title">ABOUT</div>
                <div id="youtube" className={contentClass}>
                    {nowData.about.map((a, i) => {

                        return (
                            <div key={"a_" + i}>{a.type === "text" ? <div>{a.content.map((ac, i) => <p className="work-item" key={"ac" + i} dangerouslySetInnerHTML={convertMarkdownToHTML(ac)} />)}</div> :
                                (a.type === "movie" ? <div className="movie-wrapper">
                                    <YouTube className="youtube-wrapper" opts={opts} videoId={a.content} style={{ aspectRatio: "16/9", width: (ua === "pc" ? "80%" : "100%"), display: "flex", justifyContent: "center", height: youtubeHeight + "px" }} />
                                </div> : <div className="movie-wrapper"><img className={ua === "pc" ? "img-wrapper" : "img-wrapper-sp"} src={"/works/" + id + "/" + a.content} alt={id} /></div>)}</div>
                        );
                    })}
                </div>
                <div className={"title" + (nowData.publication.length > 0 ? "" : " hidden-div")}>PUBLICATION</div>
                <div className={contentClass}>
                    {nowData.publication.map((d, i) =>
                        createPubLine(d, "j_" + i, i + 1)
                    )}
                </div>
                <div className={"title" + (nowData.media.length > 0 ? "" : " hidden-div")}>MEDIA</div>
                <div className={contentClass}>
                    {nowData.media.map((d, i) =>
                        <li key={"m" + i} className="work-pub">
                            {d.content}
                            <a className="work-link" href={d.link}>{d.link === undefined ? "" : "[link]"}</a>
                        </li>
                    )}
                </div>
                <div className="title">{"CONTRIBUTOR" + (nowData.contributor.length === 0 ? "" : "S")}</div>
                <div className={contentClass}>
                    {nowData.contributor.map((d, i) =>
                        <li key={"c" + i} className="work-pub">
                            {d.link === undefined ? <span>{d.name}</span> : <a href={d.link}>{d.name}</a>}
                        </li>
                    )}
                </div>
            </div>
        </div>
    );
};


class ParallaxEffectBackground {
    constructor() {
        this.devided = 5;
        this.target = '.container';
        this.setBackgroundPosition();
    }

    getScrollTop() {
        return Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop,
            window.scrollY
        );
    }

    setBackgroundPosition() {
        document.addEventListener('scroll', e => {
            const scrollTop = this.getScrollTop();
            const position = scrollTop / this.devided;
            if (position) {
                document.querySelectorAll(this.target).forEach(element => {
                    element.style.backgroundPosition = 'center top -' + position + 'px';
                });
            }
        });
    }
}

//<div id="work-header-sp">
//<p className="title-word-sp" dangerouslySetInnerHTML={convertMarkdownToHTML(nowData.title)} />
//</div>